import { publicKeys } from '@/api/query-keys';
import { useQuery } from '@tanstack/react-query';
import type { components } from '@/api/generated-types';
import { useLanguage } from '@/i18n/language-context';
import { publicRequest as send } from '@/api/public-client';

export type ChurchHierarchy = components['schemas']['PublicOrganizationHierarchyResponseDto'];
export type Union = ChurchHierarchy['unions'][number];
export type Conference = Union['conferences'][number];
export type Church = Conference['churches'][number];
export function churchPaths(
  data?: ChurchHierarchy,
): { union: Union; conference: Conference; church: Church }[] {
  return (data?.unions ?? []).flatMap((union) =>
    union.conferences.flatMap((conference) =>
      conference.churches.map((church) => ({ union, conference, church })),
    ),
  );
}
export function useChurchHierarchy(enabled = true) {
  const { locale } = useLanguage();
  return useQuery({
    queryKey: publicKeys.hierarchy(locale),
    queryFn: ({ signal }) => send<ChurchHierarchy>('/organizations/hierarchy', locale, { signal }),
    enabled,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
export { normalizeSearchText as normalizeChurchSearch } from '@/lib/search-text';
